"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meter = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
exports.Meter = function (props) {
    var max = props.max ? props.max : 100;
    var min = props.min ? props.min : 0;
    var valuePercent = Math.round(((props.value - min) / (max - min)) * 100) + "%";
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays(["c-meter"], utilityClasses);
    return (react_1.default.createElement("meter", { min: min, max: max, low: props.low ? props.low : Math.round(min + (max - min) * 0.25), optimum: props.optimum ? props.optimum : Math.round(min + (max - min) / 2), high: props.high ? props.high : Math.round(min + (max - min) * 0.75), value: props.value, className: classes.join(" ") },
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { style: { width: valuePercent } }))));
};
//# sourceMappingURL=Meter.js.map